module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.refundStatus || locals.purchased) { 
    ; __append(" <button class=\"refund btn btn-clear btn-block\" ")
    ; __append(escapeFn( locals.refundStatus ? 'disabled': '' ))
    ; __append("> ")
    ;  if (locals.refundStatus) { 
    ; __append(" ")
    ; __append(escapeFn( locals.refundStatus ))
    ; __append(" ")
    ;  } else if (locals.purchased) { 
    ; __append(" Refund ")
    ;  } 
    ; __append(" </button> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/shipments/refund_button.ejs
// module id = 1834
// module chunks = 1